import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useSocket } from '../context/WebsocketContext';
import { MY_PENDING_REWRITE_POSTS_QUERY } from '../graphql/resolvers/postQueries/myPendingRewritePosts.gql';

/**
 * Live count + list of the viewer's posts awaiting rewrite. Refetches on the
 * websocket events the author already receives so the count stays accurate
 * (++ on a REWRITE verdict, -- on republish).
 */
export function useMyPendingRewrites() {
  const { user } = useAuth();
  const isSignedIn = Boolean(user?.id);

  const { data, loading, refetch } = useQuery(MY_PENDING_REWRITE_POSTS_QUERY, {
    fetchPolicy: 'cache-and-network',
    skip: !isSignedIn,
  });

  const { onEvent } = useSocket();

  useEffect(() => {
    if (!isSignedIn) return;
    const offStatus = onEvent('post_status_changed', () => {
      void refetch();
    });
    const offResolved = onEvent('report_resolved', () => {
      void refetch();
    });
    return () => {
      offStatus();
      offResolved();
    };
  }, [isSignedIn, onEvent, refetch]);

  const posts = data?.myPendingRewritePosts ?? [];
  return { posts, count: posts.length, loading };
}
